import login from './login';

export default {
  language: 'hu',
  country: 'hu',
  name: 'Magyar',
  embeddedLocale: login,
};
